export default __webpack_public_path__ + "static/img02-dd0e3d457d3b28b931839d104a391c71.webp";